/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface YardInventoryRowResponse
 */
export interface YardInventoryRowResponse {
    /**
     * 
     * @type {number}
     * @memberof YardInventoryRowResponse
     */
    mineLocationId?: number;
    /**
     * 
     * @type {string}
     * @memberof YardInventoryRowResponse
     */
    mineLocationName?: string;
    /**
     * 
     * @type {number}
     * @memberof YardInventoryRowResponse
     */
    siteId?: number;
    /**
     * 
     * @type {string}
     * @memberof YardInventoryRowResponse
     */
    siteName?: string;
    /**
     * 
     * @type {string}
     * @memberof YardInventoryRowResponse
     */
    customerName?: string;
    /**
     * 
     * @type {number}
     * @memberof YardInventoryRowResponse
     */
    equipmentId?: number;
    /**
     * 
     * @type {string}
     * @memberof YardInventoryRowResponse
     */
    bucketName?: string;
    /**
     * 
     * @type {number}
     * @memberof YardInventoryRowResponse
     */
    partsCount?: number;
    /**
     * 
     * @type {Date}
     * @memberof YardInventoryRowResponse
     */
    lastInspectionDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof YardInventoryRowResponse
     */
    daysAtLocation?: number;
}

/**
 * Check if a given object implements the YardInventoryRowResponse interface.
 */
export function instanceOfYardInventoryRowResponse(value: object): value is YardInventoryRowResponse {
    return true;
}

export function YardInventoryRowResponseFromJSON(json: any): YardInventoryRowResponse {
    return YardInventoryRowResponseFromJSONTyped(json, false);
}

export function YardInventoryRowResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): YardInventoryRowResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'mineLocationId': json['mineLocationId'] == null ? undefined : json['mineLocationId'],
        'mineLocationName': json['mineLocationName'] == null ? undefined : json['mineLocationName'],
        'siteId': json['siteId'] == null ? undefined : json['siteId'],
        'siteName': json['siteName'] == null ? undefined : json['siteName'],
        'customerName': json['customerName'] == null ? undefined : json['customerName'],
        'equipmentId': json['equipmentId'] == null ? undefined : json['equipmentId'],
        'bucketName': json['bucketName'] == null ? undefined : json['bucketName'],
        'partsCount': json['partsCount'] == null ? undefined : json['partsCount'],
        'lastInspectionDate': json['lastInspectionDate'] == null ? undefined : (new Date(json['lastInspectionDate'])),
        'daysAtLocation': json['daysAtLocation'] == null ? undefined : json['daysAtLocation'],
    };
}

export function YardInventoryRowResponseToJSON(json: any): YardInventoryRowResponse {
    return YardInventoryRowResponseToJSONTyped(json, false);
}

export function YardInventoryRowResponseToJSONTyped(value?: YardInventoryRowResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mineLocationId': value['mineLocationId'],
        'mineLocationName': value['mineLocationName'],
        'siteId': value['siteId'],
        'siteName': value['siteName'],
        'customerName': value['customerName'],
        'equipmentId': value['equipmentId'],
        'bucketName': value['bucketName'],
        'partsCount': value['partsCount'],
        'lastInspectionDate': value['lastInspectionDate'] === null ? null : ((value['lastInspectionDate'] as any)?.toISOString()),
        'daysAtLocation': value['daysAtLocation'],
    };
}

